// extracted by mini-css-extract-plugin
module.exports = {"cell":"Item_cell__nydKM","event":"Item_event__3o_R0","eventName":"Item_eventName__m26Tz"};